import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const EMPTY = { date: "", time: "", opponent: "", location: "" };

export function WeekDialog({ open, week, onClose, onSave, busy }) {
  const [form, setForm] = useState(EMPTY);
  useEffect(() => {
    if (open) setForm(week ? { date: week.date || "", time: week.time || "", opponent: week.opponent || "", location: week.location || "" } : EMPTY);
  }, [open, week]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const inputCls = "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-orange-400";
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent aria-describedby={undefined} className="border-slate-200 bg-white text-slate-900" data-testid="week-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl uppercase tracking-wide">{week ? "Edit week" : "Add game week"}</DialogTitle>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSave(form);
          }}
          className="space-y-3"
        >
          <div className="grid grid-cols-2 gap-3">
            <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
              Date
              <input data-testid="week-date-input" type="date" value={form.date} onChange={set("date")} className={inputCls} />
            </label>
            <label className="space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
              Time
              <input data-testid="week-time-input" type="time" value={form.time} onChange={set("time")} className={inputCls} />
            </label>
          </div>
          <label className="block space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
            Opponent
            <input data-testid="week-opponent-input" value={form.opponent} onChange={set("opponent")} placeholder="e.g. Northside Wolves" className={inputCls} />
          </label>
          <label className="block space-y-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
            Location
            <input data-testid="week-location-input" value={form.location} onChange={set("location")} placeholder="e.g. City Stadium Court 2" className={inputCls} />
          </label>
          <button
            data-testid="week-save-button"
            type="submit"
            disabled={busy}
            className="w-full rounded-lg bg-orange-500 py-2.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-400 disabled:opacity-40"
          >
            {busy ? "Saving…" : "Save week"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
